import { useTheme } from '@mui/material';
import { useAppSelector } from 'app/hooks';
import DataRequired from 'components/data-required';
import { Urls } from 'config/urls';
import { PaymentMethod } from 'features/payment/interfaces';
import { selectDataRequired } from 'features/payment/payment-slice';
import styles from './styles.module.scss';
import { LoadingData } from 'components/loading-data';
import { useEffect, useRef } from 'react';
import { scrollToElement } from 'utils';
import { useTranslation } from 'react-i18next';

interface APMSectionProps {
  paymentMethos: PaymentMethod[];
  paymentMethodSelected: PaymentMethod | null;
  onChange: (pm: PaymentMethod) => void;
}

const APMSection = ({ paymentMethos, paymentMethodSelected, onChange }: APMSectionProps) => {
  const { t } = useTranslation();
  const dataWrapper = useRef(null);
  const theme = useTheme();
  const { loading, inputs } = useAppSelector(selectDataRequired);

  useEffect(() => {
    if (loading && dataWrapper) scrollToElement(dataWrapper);
  }, [loading]);

  return (
    <div className={styles.apm_section}>
      <div className={styles.apm_section_title}>{t('checkoutContent.chooseAnOption')}</div>
      {paymentMethos.map((pm, idx) => (
        <div
          key={idx}
          className={styles.apm_section_square}
          style={{
            ...(paymentMethodSelected?.id === pm.id ? { border: `2px solid ${theme.palette.primary.main}` } : {}),
          }}
          onClick={() => {
            if (paymentMethodSelected?.id !== pm.id) onChange(pm);
          }}
        >
          <img
            src={`${Urls.paymentMethodsSquare.replace(':code', pm.code)}`}
            className={styles.apm_section_logo}
            alt="apm_section__logo"
          />
          <div className={styles.apm_section_name}>{pm.name}</div>
        </div>
      ))}
      <div ref={dataWrapper}>
        {loading && <LoadingData />}
        {inputs && <DataRequired />}
      </div>
    </div>
  );
};

export default APMSection;
